var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBackStreet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "59px",
    viewBox: "0 0 52 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,0 32,7.18018102 32,16.0373832 C32,20.8685844 29.8687274,25.2008371 26.4971752,28.1410666 L16.0250448,39 L5.52692836,28.1620446 C2.1414336,25.221464 0,20.8800872 0,16.0373832 C0,7.18018102 7.163444,0 16,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-53.1%",
    y: "-33.3%",
    width: "206.2%",
    height: "187.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.50098552,0.0695179381 L6.6250595,0.0695179381 L6.54858977,2.39141707 L7.57745526,2.39141707 L7.50098552,0.0695179381 Z M7.61916602,3.54541484 L6.50687901,3.54541484 L6.34698775,8.18226132 L7.76515369,8.18226132 L7.61916602,3.54541484 Z M6.30527699,9.33625909 L6.15233752,13.9035876 L7.9737075,13.9035876 L7.81381625,9.33625909 L6.30527699,9.33625909 L6.30527699,9.33625909 Z M12.541036,5.26250792 L8.6480315,5.26250792 L9.04428375,8.02932185 L13.1388903,8.02932185 C12.9442401,7.14644404 12.7356863,6.17319291 12.541036,5.26250792 Z M0.987154721,8.01541827 L4.91491823,8.01541827 L5.30421868,5.24860433 L1.64062334,5.24860433 C1.42511773,6.17319291 1.20266033,7.13949225 0.987154721,8.01541827 Z M11.7624351,2.03687559 C11.3661829,0.632613237 10.587582,0.125132289 9.46834317,0.125132289 L7.88333418,0.125132289 L8.3143454,3.1491626 L12.0266033,3.1491626 C11.9223264,2.66948882 11.8250013,2.28018837 11.7624351,2.03687559 Z M13.7854071,10.8030876 C13.7506482,10.6988107 13.7158892,10.5458712 13.6672266,10.351221 L9.37796985,10.351221 L9.86459542,13.743716 L12.9303365,13.743716 C14.2372737,13.7506482 14.1051896,11.9084228 13.7854071,10.8030876 Z M0.347589691,10.5806302 C-0.215505608,12.5966504 0.152939464,13.7506482 1.52244285,13.7506482 L4.10851014,13.7506482 L4.58818392,10.3581728 L0.410155835,10.3581728 C0.389300454,10.4276907 0.368445072,10.5111122 0.347589691,10.5806302 Z M2.54435654,1.82136998 C2.45398322,2.12724891 2.32885093,2.59301909 2.19676685,3.15611439 L5.64485658,3.15611439 L6.068916,0.132084082 L4.11546194,0.132084082 C3.2603913,0.201602021 3.00317493,0.271119959 2.54435654,1.82136998 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-25.2%",
    y: "-18.1%",
    width: "150.3%",
    height: "150.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u65B0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 11,
    transform: "translate(-601.000000, -483.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-16",
    transform: "translate(611.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408\\u5907\\u4EFD"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0056FE",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u9053\\u8DEF",
    transform: "translate(9.000000, 8.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 13.9035876,
    height: 13.9035876
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackStreet);
export default __webpack_public_path__ + "static/media/icon_back_street.6354333e6b9b8f2e76d77af364a0f51f.svg";
export { ForwardRef as ReactComponent };